import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from 'react-toastify';
import { FaUser, FaCalendarAlt, FaUserMd, FaSave } from "react-icons/fa";
import '../styles/DutyRoster.css';

const DutyRoster = () => {
     const token = sessionStorage.getItem("token") || localStorage.getItem("token");
     const BASE_URL = process.env.REACT_APP_BASE_URL;
     const [employees, setEmployees] = useState([]);
     const [selectedEmployee, setSelectedEmployee] = useState("");
     const [shiftslist, setShiftslist] = useState([]);
     const [doctorShifts, setDoctorShifts] = useState([]);
     const [poojariShifts, setPoojariShifts] = useState([]);
     const [selectedMonth, setSelectedMonth] = useState("");
     const [days, setDays] = useState([]);
     const [rosterData, setRosterData] = useState([]);
     const [employeeInputValue, setEmployeeInputValue] = useState("");
     const [isEditMode, setIsEditMode] = useState(false);
     const [employeeType, setEmployeeType] = useState("");
     const [fixedWeekoffDay, setFixedWeekoffDay] = useState("");
     const [employeeDetails, setEmployeeDetails] = useState(null);
     const emp_type = employeeDetails ? employeeDetails.emp_type : "";

     useEffect(() => {
          fetchEmployees();
          fetchShifts();
          fetchDoctorShifts();
          // fetchPoojariShifts();
     }, []);

     const fetchEmployees = async () => {
          try {
               const response = await fetch(`${BASE_URL}/getEmployees`, {
                    method: "GET",
                    headers: {
                         "Content-Type": "application/json",
                         "Authorization": `Bearer ${token}`,
                    },
               });
               const result = await response.json();
               setEmployees(Array.isArray(result.data) ? result.data : []);
          } catch (error) {
               console.error("Error fetching employees:", error);
          }
     };

     const fetchShifts = async () => {
          try {
               const response = await fetch(`${BASE_URL}/getShifts`, {
                    method: "GET",
                    headers: {
                         "Content-Type": "application/json",
                         "Authorization": `Bearer ${token}`,
                    },
               });
               const result = await response.json();
               setShiftslist(Array.isArray(result.data) ? result.data : []);
          } catch (error) {
               console.error("Error fetching shifts:", error);
          }
     };

     const fetchDoctorShifts = async () => {
          try {
               const response = await fetch(`${BASE_URL}/getDoctorShifts`, {
                    method: "GET",
                    headers: {
                         "Content-Type": "application/json",
                         "Authorization": `Bearer ${token}`,
                    },
               });
               const result = await response.json();
               setDoctorShifts(Array.isArray(result.data) ? result.data : []);
          }
          catch (error) {
               console.error("Error fetching doctor shifts:", error);
          }
     };

     const fetchPoojariShifts = async () => {
          try {
               const response = await fetch(`${BASE_URL}/getPoojariShifts`, {
                    method: "GET",
                    headers: {
                         "Content-Type": "application/json",
                         "Authorization": `Bearer ${token}`,
                    },
               });
               const result = await response.json();
               setPoojariShifts(Array.isArray(result.data) ? result.data : []);
          }
          catch (error) {
               console.error("Error fetching poojari shifts:", error);
          }
     }


     useEffect(() => {
          if (selectedMonth) {
               const [year, month] = selectedMonth.split("-");
               const firstDay = new Date(year, month - 1, 1);
               const startDayOfWeek = firstDay.getDay(); // 0 = Sunday, 1 = Monday, etc.
               const daysInMonth = new Date(year, month, 0).getDate();
               const daysArr = [];

               // Add empty placeholder days for days before month starts
               for (let i = 0; i < startDayOfWeek; i++) {
                    daysArr.push({
                         date: null,
                         shift_id: "",
                         weekoff: false,
                         isEmpty: true
                    });
               }

               // Add actual days of the month
               for (let i = 1; i <= daysInMonth; i++) {
                    const dateStr = `${year}-${month.padStart(2, "0")}-${String(i).padStart(2, "0")}`;
                    daysArr.push({
                         date: dateStr,
                         shift_id: "",
                         weekoff: false,
                         isEmpty: false
                    });
               }
               setDays(daysArr);
               setRosterData(daysArr);
          } else {
               setDays([]);
               setRosterData([]);
          }
     }, [selectedMonth]);

     useEffect(() => {
          const fetchRoster = async () => {
               if (selectedEmployee && selectedMonth) {
                    try {
                         const empRes = await fetch(`${BASE_URL}/getEmpByIdNew/${selectedEmployee}`, {
                              method: "GET",
                              headers: {
                                   "Content-Type": "application/json",
                                   "Authorization": `Bearer ${token}`,
                              },
                         });
                         const empResult = await empRes.json();
                         setEmployeeDetails(empResult.data);

                         if (empResult.data && empResult.data.week_off) {
                              setEmployeeType(empResult.data.week_off);
                              if (empResult.data && empResult.data.week_off === "Fixed_weekend") {
                                   setFixedWeekoffDay(empResult.data.fixed_weekoff_day || "Sunday");
                              }
                         } else {
                              setEmployeeType("");
                         }

                         const response = await fetch(
                              `${BASE_URL}/getDutyRosterByEmpIdAndSelectedMonth/${selectedEmployee}/${selectedMonth}`,
                              {
                                   method: "GET",
                                   headers: {
                                        "Content-Type": "application/json",
                                        "Authorization": `Bearer ${token}`,
                                   },
                              }
                         );
                         const result = await response.json();

                         if (Array.isArray(result.data) && result.data.length > 0) {
                              setIsEditMode(true);
                              const mapped = result.data.map(item => ({
                                   date: item.attendance_date,
                                   shift_id: item.custom_weekoff_date ? "" : item.shift_id,
                                   weekoff: !!item.custom_weekoff_date,
                              }));
                              setRosterData(mapped);
                         } else {
                              setIsEditMode(false);
                              const [year, month] = selectedMonth.split("-");
                              const daysInMonth = new Date(year, month, 0).getDate();
                              const daysArr = [];
                              for (let i = 1; i <= daysInMonth; i++) {
                                   const dateStr = `${year}-${month.padStart(2, "0")}-${String(i).padStart(2, "0")}`;
                                   daysArr.push({
                                        date: dateStr,
                                        shift_id: "",
                                        weekoff: false,
                                   });
                              }
                              setRosterData(daysArr);

                              if (empResult.data && empResult.data.week_off === "Fixed_weekend") {
                                   setRosterData(prev =>
                                        prev.map(row => {
                                             const dateObj = new Date(row.date);
                                             const dayName = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][dateObj.getDay()];
                                             if (dayName === fixedWeekoffDay) {
                                                  return { ...row, weekoff: true, shift_id: "" };
                                             } else {
                                                  return { ...row, weekoff: false };
                                             }
                                        })
                                   );
                              }
                         }
                    } catch (error) {
                         console.error("Error fetching roster or employee details:", error);
                    }
               }
          };
          fetchRoster();
     }, [selectedEmployee, selectedMonth, BASE_URL, token]);

     const handleRosterChange = (idx, field, value) => {
          const updated = [...rosterData];
          updated[idx][field] = value;

          if (!isEditMode && field === "shift_id" && idx === 0) {
               if (employeeType === "Fixed_weekend") {
                    for (let i = 1; i < updated.length; i++) {
                         if (!updated[i].weekoff) {
                              updated[i].shift_id = value;
                         }
                    }
               } else {
                    for (let i = 1; i < updated.length; i++) {
                         updated[i].shift_id = value;
                    }
               }
          }

          setRosterData(updated);
     };

     const handleEmployeeChange = (e) => {
          const value = e.target.value;
          const found = employees.find(emp =>
               `${emp.employee_code} - ${emp.employee_name}` === value
          );
          setSelectedEmployee(found ? found.emp_id : "");
          setEmployeeInputValue(value);
          setEmployeeType(found ? found.weekend_type : "");
     };

     const handleSubmit = async () => {
          const payload = {
               emp_id: selectedEmployee,
               month: selectedMonth,
               roster: rosterData,
          };

          const loadingToast = toast.loading("Saving duty roster...");
          try {
               let result;
               if (isEditMode) {
                    const response = await fetch(`${BASE_URL}/updateDutyRosterBulk`, {
                         method: "POST",
                         headers: {
                              "Content-Type": "application/json",
                              "Authorization": `Bearer ${token}`,
                         },
                         body: JSON.stringify(payload),
                    });
                    result = await response.json();
               } else {
                    const response = await fetch(`${BASE_URL}/createDutyRoster`, {
                         method: "POST",
                         headers: {
                              "Content-Type": "application/json",
                              "Authorization": `Bearer ${token}`,
                         },
                         body: JSON.stringify(payload),
                    });
                    result = await response.json();
               }

               toast.update(loadingToast, {
                    render: `Duty roster ${isEditMode ? 'updated' : 'saved'} successfully!`,
                    type: 'success',
                    isLoading: false,
                    autoClose: 3000
               });

               setSelectedEmployee("");
               setSelectedMonth("");
               setEmployeeInputValue("");
               setRosterData([]);
               setEmployeeDetails(null);
               setIsEditMode(false);
               setEmployeeType("");
               setFixedWeekoffDay("Sunday");
          } catch (error) {
               toast.update(loadingToast, {
                    render: "Error saving roster",
                    type: 'error',
                    isLoading: false,
                    autoClose: 3000
               });
          }
     };

     useEffect(() => {
          if (employeeType === "Fixed_weekend" && rosterData.length > 0 && fixedWeekoffDay) {
               const updated = rosterData.map(row => {
                    const dateObj = new Date(row.date);
                    const dayName = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][dateObj.getDay()];
                    if (dayName === fixedWeekoffDay) {
                         return { ...row, weekoff: true, shift_id: "" };
                    } else {
                         return { ...row, weekoff: false };
                    }
               });
               setRosterData(updated);
          }
          // eslint-disable-next-line
     }, [fixedWeekoffDay, employeeType, selectedMonth]);

     const selectedEmployeeObj = employees.find(emp => emp.emp_id === selectedEmployee);
     const selectedEmployeeName = selectedEmployeeObj ? selectedEmployeeObj.employee_name : "";

     return (
          <div className="duty-roster-wrapper">
               <ToastContainer position="top-right" />

               <div className="roster-header">
                    <h2>Duty Roster</h2>
               </div>

               <div className="roster-main-card">
                    {/* Filters */}
                    <div className="roster-filters-container">
                         <div className="filter-group employee-group">
                              <label>
                                   <FaUser /> Employee
                              </label>
                              <input
                                   className="filter-input"
                                   type="text"
                                   placeholder="Select Employee"
                                   list="employees"
                                   value={employeeInputValue}
                                   onChange={handleEmployeeChange}
                                   autoComplete="off"
                              />
                              <datalist id="employees">
                                   {employees.map(emp => (
                                        <option
                                             key={emp.emp_id}
                                             value={`${emp.employee_code} - ${emp.employee_name}`}
                                        />
                                   ))}
                              </datalist>
                         </div>

                         <div className="filter-group month-group">
                              <label>
                                   <FaCalendarAlt /> Month
                              </label>
                              <input
                                   type="month"
                                   className="filter-input"
                                   min="2025-08"
                                   value={selectedMonth}
                                   onChange={e => setSelectedMonth(e.target.value)}
                                   disabled={!selectedEmployee}
                              />
                         </div>

                         {employeeType === "Fixed_weekend" && (
                              <div className="filter-group weekoff-group">
                                   <label>
                                        <FaCalendarAlt /> Fixed Weekly Off
                                   </label>
                                   <select
                                        className="filter-input"
                                        value={fixedWeekoffDay}
                                        onChange={e => {
                                             const selectedDay = e.target.value;
                                             setFixedWeekoffDay(selectedDay);

                                             // Only map if a day is selected
                                             if (selectedDay) {
                                                  setRosterData(prev =>
                                                       prev.map(row => {
                                                            const dateObj = new Date(row.date);
                                                            const dayName = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][dateObj.getDay()];
                                                            if (dayName === selectedDay) {
                                                                 return { ...row, weekoff: true, shift_id: "" };
                                                            } else {
                                                                 return { ...row, weekoff: false };
                                                            }
                                                       })
                                                  );
                                             } else {
                                                  // If "Select Day" is chosen, remove all weekoffs
                                                  setRosterData(prev =>
                                                       prev.map(row => ({
                                                            ...row,
                                                            weekoff: false
                                                       }))
                                                  );
                                             }
                                        }}
                                   >
                                        <option value="">Select Day</option>
                                        {["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"].map(day => (
                                             <option key={day} value={day}>{day}</option>
                                        ))}
                                   </select>
                              </div>
                         )}

                         {selectedEmployee && selectedMonth && (
                              <div className="filter-group action-group">
                                   <button className="save-btn" onClick={handleSubmit}>
                                        <FaSave /> {isEditMode ? 'Update' : 'Save'} Roster
                                   </button>
                              </div>
                         )}

                         {/* need button to redirect to bulk mapping */}
                         <div className="filter-group action-group">
                              <button className="bulk-map-btn" onClick={() => { window.location.href = '/dutyrosterbulk'; }}>
                                   <FaUserMd /> Bulk Map Roster
                              </button>
                         </div>
                    </div>

                    {/* Roster Grid */}
                    {selectedEmployee && selectedMonth && rosterData.length > 0 ? (
                         <div className="roster-grid-container">
                              {rosterData.map((row, index) => {
                                   // Handle empty placeholder cells
                                   if (row.isEmpty) {
                                        return <div key={`empty-${index}`} className="roster-day-card empty-card"></div>;
                                   }

                                   const dateObj = new Date(row.date);
                                   const dd = String(dateObj.getDate()).padStart(2, "0");
                                   const dayName = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][dateObj.getDay()];
                                   const isWeekend = dateObj.getDay() === 0;

                                   return (
                                        <div
                                             key={row.date}
                                             className={`roster-day-card ${isWeekend ? 'weekend-card' : ''} ${row.weekoff ? 'weekoff-selected' : ''}`}
                                        >
                                             <div className="day-header">
                                                  <span className="date-number">{dd}</span>
                                                  <span className="day-name">{dayName}</span>
                                             </div>
                                             <div className="day-content">
                                                  <select
                                                       className="shift-select"
                                                       value={row.shift_id}
                                                       onChange={e => handleRosterChange(index, "shift_id", e.target.value)}
                                                       disabled={row.weekoff}
                                                  >
                                                       <option value="">Select Shift</option>
                                                       {emp_type === "CONTRACTUAL_EMPLOYEE" && shiftslist.map(shift => (
                                                            <option key={shift.id} value={shift.id}>
                                                                 {shift.ShiftName}
                                                            </option>
                                                       ))}
                                                       {emp_type === "DOCTOR" && doctorShifts.map(shift => (
                                                            <option key={shift.id} value={shift.id}>
                                                                 {shift.shift_name} ({shift.in_time} - {shift.out_time})
                                                            </option>
                                                       ))}
                                                       {emp_type === "POOJARI" && poojariShifts.map(shift => (
                                                            <option key={shift.id} value={shift.id}>
                                                                 {shift.shift_name} ({shift.in_time} - {shift.out_time})
                                                            </option>
                                                       ))}
                                                       {/* Fallback to shiftslist if emp_type is missing or unknown */}
                                                       {!emp_type && shiftslist.map(shift => (
                                                            <option key={shift.id} value={shift.id}>
                                                                 {shift.ShiftName}
                                                            </option>
                                                       ))}
                                                  </select>
                                                  <label className="weekoff-checkbox">
                                                       <input
                                                            type="checkbox"
                                                            checked={row.weekoff}
                                                            onChange={() => {
                                                                 setRosterData(prev =>
                                                                      prev.map((item, idx) =>
                                                                           idx === index
                                                                                ? { ...item, weekoff: !item.weekoff, shift_id: !item.weekoff ? "" : item.shift_id }
                                                                                : item
                                                                      )
                                                                 );
                                                            }}
                                                            disabled={employeeType === "Fixed_weekend"}
                                                       />
                                                       <span>Week Off</span>
                                                  </label>
                                             </div>
                                        </div>
                                   );
                              })}
                         </div>
                    ) : (
                         selectedEmployee && selectedMonth ? (
                              <div className="no-data-message">
                                   <p>No roster data available</p>
                              </div>
                         ) : (
                              <div className="no-data-message">
                                   <p>Please select employee and month to manage duty roster</p>
                              </div>
                         )
                    )}
               </div>
          </div >
     );
};

export default DutyRoster;